// extracted by mini-css-extract-plugin
export default {"button":"delete_watcher_button-module__button--6SzNY"};